import axios, { getData } from "./axios";
import * as tPromise from "io-ts-promise";
import { routeCargoRoadTollResponseT, signedFileUrlT } from "dora-contracts";

export const performSmartmatchForRoute = async (route_id: number) => {
  await axios.post(`/api/perform-smartmatch-for-route/${route_id}`);
};

export const getEstimatedDistanceForCoords = async (
  coords: { lat: number; lon: number }[]
) => {
  return axios.post(`/api/get-estimated-distance-for-coords`, { coords });
};

export const getDanishRoadTollTaxForCargo = async (cargoId: string) => {
  return axios
    .get(`/api/cargos/${cargoId}/route-road-toll`)
    .then(getData)
    .then(tPromise.decode(routeCargoRoadTollResponseT));
};

export const regenerateRoutingWithRoadTollForCargo = async (cargoId: string) => {
  return axios.post(`/api/cargos/${cargoId}/route-road-toll`);
}

// `signedUrlEndpoint` is a server-provided `/files/s3/:id` url (e.g. `urlNew`)
export const getSignedFileUrl = async (signedUrlEndpoint: string) => {
  return axios
    .get(signedUrlEndpoint)
    .then(getData)
    .then(tPromise.decode(signedFileUrlT));
};

// One CMR for a pickup/dropoff pair of a cargo, or for one of its saved CMR
// configs. Without pickup/dropoff the server renders the cargo's first pair.
export type CmrPdfParams =
  | { cargoId: string; pickup?: number; dropoff?: number }
  | { cmrConfigId: string };

export const getCmrPdf = async (params: CmrPdfParams): Promise<Blob> => {
  return axios
    .get("/api/cmr/pdf", { params, responseType: "blob" })
    .then((res) => new Blob([res.data], { type: "application/pdf" }));
};
